import * as React from "react";
import { Col, Row, Button } from "reactstrap";
import { IAgency } from "./../../../../../share/types/agency";

export interface IAgencyCardProps {
  agency: IAgency;
  history: any;
}

const AgencyCard = ({ agency, history }: IAgencyCardProps) => {
  return (
    <Col xl="4" lg="6" md="12" sm="12" xs="12" className="card-column">
      <div className="info-card white-background">
        <Row>
          <Col md="3" sm="3" xs="3">
            <div className="logo-background">
              <img src={agency.logo.url} alt="Logo" />
            </div>
          </Col>
          <Col md="9" sm="9" xs="9" className="card-head">
            <div className="agency-name">{agency.name}</div>
            <div className="agency-data">
              <p>
                <label>Country:</label>
                <span className="subFont">{agency.country}</span>
              </p>
              <p>
                <label>Email:</label>
                <a href={`mailto:${agency.email}`}>
                  <span className="subFont">{agency.email}</span>
                </a>
              </p>
              <p>
                <label>Code:</label>
                <span className="subFont">{agency.code}</span>
              </p>
            </div>
          </Col>
        </Row>
        <Row className="top-space">
          <Col md="6" />
          <Col md="6">
            <Button className="btn-blue btn-view" onClick={() => history.push(`/agencies/info/${agency.code}`)}>
              View
            </Button>
          </Col>
        </Row>
      </div>
    </Col>
  );
};

export default AgencyCard;



// WEBPACK FOOTER //
// ./src/modules/Agencies/Agency/View/components/AgencyCard.tsx